exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.accent-picker-container .accent-picker-title{text-align:center;padding-top:24px;font-family:Open Sans,sans-serif;font-weight:600;font-size:12px;color:#000;letter-spacing:1px}.accent-picker-container .accent-colors-container{display:grid;grid-template-columns:repeat(5,34px);grid-template-rows:repeat(4,32px);grid-column-gap:16px;grid-row-gap:16px}.accent-picker-container .accent-colors-container .accent-outline{cursor:pointer;display:flex;justify-content:center;align-items:center;height:34px;width:34px;background-color:#fff;z-index:1;border-radius:6px;margin-right:4px;margin-top:8px}.accent-picker-container .accent-colors-container .accent-outline .accent-color{border-radius:4px;height:32px;width:32px;z-index:2}.accent-picker-container .accent-instructions{font-family:Open Sans,sans-serif;font-weight:300;color:#8b8b8b;letter-spacing:0;white-space:nowrap;margin-top:24px;font-size:10px;font-style:italic;text-align:center}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/CompaniesContainer/AccentPicker/AccentPicker.scss
// module id = 1712
// module chunks = 0